module.exports = __webpack_public_path__ + "img/no-avatar-image.6dbc4291.gif";